const PASSWORD_REGEX = /^\S*(?=\S{6,})(?=\S*\d)(?=\S*[A-Z])(?=\S*[a-z])(?=\S*[!@#$%^&*? ])\S*$/;
const PLACEHOLDER_TEXT = "At least 6 characters, 1 number";

const OldPasswordSchema = {
  type: "object",
  properties: {
    oldPwd: {
      type: "string",
      uniforms: { type: "password" }
    }
  },
  required: ["oldPwd"]
};

const PasswordSchema = {
  type: "object",
  properties: {
    password: {
      type: "string",
      minLength: 6,
      pattern: PASSWORD_REGEX.source,
      uniforms: { type: "password" }
    },
    p2: {
      type: "string",
      uniforms: { type: "password" }
    }
  },
  errorMessage: {
    properties: {
      password:"Your password should have a capital and at least 1 special character and minimum 6 characters long",
    },
    required: {
      password: 'Please enter a password',
      p2: 'Please repeat your password',
    },
  },
  required: ["password", "p2"]
};

export {
  PasswordSchema, OldPasswordSchema, PASSWORD_REGEX, PLACEHOLDER_TEXT
};
